Selector.View.QuestionTabView = Backbone.View.extend(
/** @lends Selector.View.QuestionView# */
{	
	/** classname to give the generated element */
	className: "e_selector_tab",
	
	/** tagname to give this generated element */
	tagName: "div",
	
	/** template to use for Underscore.js rendering */
	template: _.template($('#selector_tab').html()),

    events: {
        "click a": 	"goToQuestion"
    },

	/** Render function */
	render: function() {
        if (this.model.get("CURRENT")) {
            $(".e_selector_tabs_nav").removeClass("disabled");
            this.$el.addClass("active");

            if (this.model.get("IDNUM") == 1) {
                $(".e_selector_tabs_left").addClass("disabled");
            }
            if (this.model.get("IDNUM") == this.model.collection.length) {
                $(".e_selector_tabs_right").addClass("disabled");
            }
        }
		this.$el.html(this.template(this.model.attributes));//render the HTML
		return this; //needed in order to chain rendering
	},

    goToQuestion: function(){
	    this.model.activate();
    }

});